import type React from "react";
import { toast } from "react-toastify";
import { ChatPagesContainer } from "~/components/common/chat/ChatPagesContainer";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { SERVER_ERROR_MESSAGE } from "~/constants/AppConst";
import useItandiAccount from "~/hooks/useItandiAccount";
import { useMessageSummaries } from "~/hooks/useMessageSummaries";
import { UPDATE_TEMPORARY_UNREAD_MESSAGE } from "~/models/Message";
import { isSuccess } from "~/utils/api/api_handler";
import { postTemporaryUnread } from "~/utils/api/deals/Message";

export const Page: React.FC = () => {
	const { data: messageSummaries, mutate: mutateMessageSummaries } =
		useMessageSummaries().index();
	const { data: account } = useItandiAccount().currentAccount();
	if (messageSummaries === null || account === null) {
		return null;
	}
	const handleTemporaryUnread = async (dealId: number): Promise<void> => {
		const result = await postTemporaryUnread(dealId);
		if (isSuccess(result)) {
			await mutateMessageSummaries?.();
			toast.success(UPDATE_TEMPORARY_UNREAD_MESSAGE);
			return;
		}
		toast.error(SERVER_ERROR_MESSAGE);
	};
	return (
		<DefaultV2>
			<ChatPagesContainer
				handleTemporaryUnread={handleTemporaryUnread}
				isAdmin={account.isAdmin}
				store={account.store}
			/>
		</DefaultV2>
	);
};
